export default (function (theme) {
  return {
    searchInput: {
      float: 'right',
      marginRight: '0.5em'
    },
    searchIcon: {
      color: 'rgba(0, 0, 0, 0.54)'
    },
    topRightExtraNode: {
      float: 'right'
    },
    headerLabels: {
      color: 'rgba(0, 0, 0, 0.54)',
      fontSize: '0.75rem',
      fontWeight: '500',
      '&:hover': {
        color: 'rgba(0, 0, 0, 0.54)'
      },
      '&:focus': {
        color: 'rgba(0, 0, 0, 0.54)'
      }
    }
  };
});